import { useCurrentUser } from "@/hooks/useCurrentUser";
import { Link } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { Button } from "@mui/material";
import Iconify from "@/components/iconify/iconify";

const FloatingToolbarContainer = styled("div", {
  label: "FloatingToolbarContainer",
})({
  position: "fixed",
  bottom: 0,
  left: "50%",
  transform: "translateX(-50%)",
  zIndex: 1200,
  display: "flex",
  alignItems: "center",
  gap: 8,

  padding: 0,
  borderRadius: 20,
});

export const TeacherFloatingToolbar = () => {
  const user = useCurrentUser();

  if (user?.id.startsWith("cli-")) {
    return null;
  }

  const dashboardlink = `/${user.role}/dashboard`;

  return (
    <FloatingToolbarContainer>
      <Button
        component={Link}
        color="secondary"
        to={dashboardlink}
        variant="contained"
        size="small"
        startIcon={<Iconify icon="eva:arrow-back-fill" width={16} />}
        sx={{
          borderRadius: 16,
          textTransform: "none",
          fontWeight: 600,
          fontSize: "0.875rem",
        }}
      >
        Exit Climber Mode
      </Button>
    </FloatingToolbarContainer>
  );
};
